var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowpassIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Suffix"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/eye-slash"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eye-slash"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.1092 8.3916L7.89258 12.6083C7.35091 12.0666 7.01758 11.3249 7.01758 10.4999C7.01758 8.84993 8.35091 7.5166 10.0009 7.5166C10.8259 7.5166 11.5676 7.84994 12.1092 8.3916Z",
    stroke: "#B9C0D4",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.8499 5.3084C13.3915 4.2084 11.7249 3.6084 9.99987 3.6084C7.0582 3.6084 4.31654 5.34173 2.4082 8.34173C1.6582 9.51673 1.6582 11.4917 2.4082 12.6667C3.06654 13.7001 3.8332 14.5917 4.66654 15.3084",
    stroke: "#B9C0D4",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.01758 16.7751C7.96758 17.1751 8.97591 17.3917 10.0009 17.3917C12.9426 17.3917 15.6842 15.6584 17.5926 12.6584C18.3426 11.4834 18.3426 9.5084 17.5926 8.3334C17.3176 7.90006 17.0176 7.49173 16.7092 7.1084",
    stroke: "#B9C0D4",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.9242 11.0833C12.7076 12.2583 11.7492 13.2166 10.5742 13.4333",
    stroke: "#B9C0D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M7.89102 12.6084L1.66602 18.8334",
    stroke: "#B9C0D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M18.3324 2.16675L12.1074 8.39175",
    stroke: "#B9C0D4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowpassIcon);
export default __webpack_public_path__ + "static/media/showpass-icon.699b18464c1c563794680e4053d4d48b.svg";
export { ForwardRef as ReactComponent };